import {
  getAlertSeverity,
  getAlertStartTime,
} from 'features/Weather/features/WeatherAlerts/utils/alertData.utils';
import {
  getAlertSeverityColor,
  getAlertSeverityLabel,
} from 'features/Weather/features/WeatherAlerts/utils/alertSeverity.utils';
import { formatDateTime } from 'utils/dates/date.utils';
import WeatherMapList, {
  WeatherMapListButton,
} from '../../../../../../components/WeatherMapList/WeatherMapList';
import {
  getSevereWeatherAlertHeadline,
  getStableSevereWeatherAlertId,
} from '../../../../utils/severeWeatherAlerts.utils';

const SevereWeatherAlertList = ({ alerts = [], selectedAlertId, onSelectAlert }) => (
  <WeatherMapList
    title="Alerts in this area"
    countLabel={`${alerts.length} ${alerts.length === 1 ? 'alert' : 'alerts'}`}
    className="severe-weather-alert-list"
    listClassName="severe-weather-alert-list-items"
  >
    {alerts.map((alert, alertIndex) => {
      const alertId = getStableSevereWeatherAlertId(alert, alertIndex);
      const severity = getAlertSeverity(alert);
      const isSelected = alertId === selectedAlertId;

      return (
        <li key={alertId}>
          <WeatherMapListButton
            isSelected={isSelected}
            className="severe-weather-alert-list-button align-items-start gap-2 p-2"
            onClick={() => onSelectAlert?.(alert)}
          >
            <span
              aria-hidden="true"
              className="severe-weather-alert-severity-swatch mt-1 flex-shrink-0 rounded-circle"
              style={{ backgroundColor: getAlertSeverityColor(severity) }}
            />
            <span className="d-flex min-w-0 flex-grow-1 flex-column gap-1">
              <span className="fw-semibold text-break">{getSevereWeatherAlertHeadline(alert)}</span>
              <span className="small text-secondary">
                {getAlertSeverityLabel(severity)} severity
              </span>
              <span className="small text-secondary">
                Starts {formatDateTime(getAlertStartTime(alert))}
              </span>
            </span>
          </WeatherMapListButton>
        </li>
      );
    })}
  </WeatherMapList>
);

export default SevereWeatherAlertList;
